/**
 * Parse numeric input supporting both Arabic-Indic and Western digits
 * Removes thousands separators (commas and periods used as separators)
 */
export const parseArabicNumber = (input) => {
  if (!input || typeof input !== 'string') return 0;
  
  const arabicToWestern = {
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
  };
  
  let normalized = input.trim();
  
  // Convert Arabic-Indic digits to Western digits
  for (let [arabic, western] of Object.entries(arabicToWestern)) {
    normalized = normalized.replace(new RegExp(arabic, 'g'), western);
  }
  
  // Remove thousand separators (comma and spaces)
  normalized = normalized.replace(/[,\s]/g, '');
  
  // Parse the number
  const value = parseFloat(normalized) || 0;
  return value;
};

/**
 * Format number for display with English digits and optional thousands separators
 */
export const formatNumber = (num, decimals = 0, useThousandsSeparator = true) => {
  const number = Number(num);
  
  if (useThousandsSeparator) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(number);
  }
  
  return number.toFixed(decimals);
};

/**
 * Legacy name for backwards compatibility - now returns English digits
 */
export const formatArabicNumber = formatNumber;
